import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import defaultImage from '../../assets/default.jpg';
// import perivy from '../../assets/privy-thumbnail.jpg';
// import perivyColor from '../../assets/logo-privy-colored.png'
// import peruri from '../../assets/peruri.png'
// import peruriColor from '../../assets/Logo-peruri.png';
// import vida from '../../assets/thumbnail-vida.jpg';
// import vidaColor from '../../assets/vida.png';
// import bppt from '../../assets/thumbnail-bppt.jpg';
// import iotentik from '../../assets/iotentik.png';
// import digisign from '../../assets/digisign-ca.jpg';
// import digisignColor from '../../assets/digisign-black.png';

export default ({listOrganizer, baseURL}) => {
  return (
    <section className="psre-dua">
      <div className="container">
        <div className="cards-ca">
          <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
            {listOrganizer.length ? listOrganizer.map((e, index) => (
                <Link className="card card-primary mb-5" to={`/organizer/${e._id}`} style={{color: 'black', width: 370, marginRight: 10, height: 420}}>
                  <div className="img-ca">
                    <img className="card-img-top" src={e.thumbnail ? baseURL+'/'+e.thumbnail : defaultImage} alt="privy-thumbnail" style={{height:'200px', objectFit: 'cover', width: '100%', borderTopLeftRadius: '8px', borderTopRightRadius: '8px'}} />
                  </div>
                  <div className="card-body" style={{padding: '30px', position: 'relative'}}>
                    <p className="text-muted" style={{fontSize: '12px', textTransform: 'uppercase'}}>{e.type}</p>
                    <p style={{fontSize: '18px', fontWeight: '600'}}>{e.companyName}</p>
                    <div className="bottom-image-ca" style={{position: 'absolute',bottom:'30px', width: '100%', paddingRight: '60px'}}>
                      <label className="text-muted" style={{fontSize: '12px'}}>{e.noRef}</label>
                      <div className="space-between"><img className="mt-2" src={e.logo ? baseURL+'/'+ e.logo : defaultImage} alt="logo-privy-colored" style={{width: 'auto', height:'30px'}} />
                        <div className="btn-green">{e.status}</div>
                      </div>
                    </div>
                  </div>
                </Link>
              )
            ) : <div>No Data Founded</div>}
          </div>
        </div>
      </div>
    </section>
  )
}
